import styles from './Loading.module.scss';

export const Loading = () => {
  return (
    <div className="flex items-center justify-center">
      <div className={styles.loader}></div>
    </div>
  );
};
